/**
 * A 204 load tender that satisfies `EDI_INBOUND_PAYLOAD_SCHEMA`, as the
 * starting point for the raw-payload tab.
 *
 * `usageIndicatorCode` is `P`, not `T`: the inbound handler returns early on a
 * `T` payload without creating anything, so a test send has to use the
 * production indicator to reach the order-create path.
 *
 * `transactionSetPurposeCode` is `ORIGINAL`, which is what real Stedi traces
 * send. The schema accepts only `ORIGINAL`, `CANCELLATION`, or `CHANGE`, and it
 * checks the value inside a Zod transform, so any other string is a schema
 * violation the backend reports rather than a value it forwards.
 *
 * `receiverId` and `senderId` are placeholders. They must be replaced with ISA
 * IDs the target environment resolves — `receiverId` (with the optional SCAC)
 * to a company, `senderId` (with the optional `senderContactCode`) to one of
 * that company's contacts. Without a match the handler records a FAILED EDI
 * transaction instead of creating an order.
 */
export const EXAMPLE_EDI_PAYLOAD = {
  senderId: "REPLACE_WITH_SENDER_ISA_ID",
  receiverId: "REPLACE_WITH_RECEIVER_ISA_ID",
  standardCarrierAlphaCode: "SCAC",
  senderContactCode: "",
  transactionSetIdentifierCode: "204",
  transactionSetPurposeCode: "ORIGINAL",
  usageIndicatorCode: "P",
  order: {
    standardOrderFields: {
      shipperBillOfLadingNumber: "HAWB-TEST-1",
    },
    pickupOrDelivery: "DELIVERY",
    mawb: "MAWB-TEST-1",
  },
  shipperInformation: {
    name: "Test Shipper",
    addressLine1: "20 W 34th St.",
    city: "New York",
    state: "NY",
    zip: "10001",
    country: "USA",
  },
  consigneeInformation: {
    name: "Test Consignee",
    addressLine1: "1 Rockefeller Plaza",
    city: "New York",
    state: "NY",
    zip: "10020",
    country: "USA",
  },
  packages: [
    {
      description: "TEST PACKAGE",
      weight: 100,
      quantity: 1,
      class: "70",
      packageType: "PALLET",
    },
  ],
};

/** The example payload as the pretty-printed JSON the editor is seeded with. */
export const EXAMPLE_EDI_PAYLOAD_JSON = JSON.stringify(
  EXAMPLE_EDI_PAYLOAD,
  null,
  2,
);
